import {
  FETCH_RIGHT_SIDEBAR_SUCCESS,
  FETCH_RIGHT_SIDEBAR_FAILURE,
  TOGGLE_RIGHT_CATEGORY,
  SELECT_RIGHT_SUBCATEGORY,
  SET_SLIDING_STATE,
} from "../actions/rightSidebarActions";

const initialState = {
  data: [], // Holds categories
  subcategories: {}, // Holds subcategories for each category_id
  status: "idle",
  error: null,
  expanded: {}, // Tracks expanded categories
  selectedSubcategory: null, // Stores category_id instead of category_name
  isSliding: false, // Controls animation state
};

const rightSidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RIGHT_SIDEBAR_SUCCESS:
      return {
        ...state,
        status: "succeeded",
        data: action.payload, // Store fetched categories
      };

    case FETCH_RIGHT_SIDEBAR_FAILURE:
      return {
        ...state,
        status: "failed",
        error: action.payload,
      };

    case TOGGLE_RIGHT_CATEGORY: {
      const { categoryId, subcategories } = action.payload;
      return {
        ...state,
        expanded: {
          ...state.expanded,
          [categoryId]: !state.expanded[categoryId], // Toggle category expansion
        },
        subcategories: {
          ...state.subcategories,
          [categoryId]: subcategories, // Store fetched subcategories
        },
      };
    }

    case SELECT_RIGHT_SUBCATEGORY:
      return {
        ...state,
        selectedSubcategory: action.payload, // Store category_id instead of category_name
      };

    case SET_SLIDING_STATE:
      return {
        ...state,
        isSliding: action.payload,
      };

    default:
      return state;
  }
};

export default rightSidebarReducer;




